import Model from "../Model";

export interface TApplicantReport {
  applicantId: number;
  partyId: string;
  firstName: string;
  lastName: string;
  fatherName: string;
  motherSurname: string;
}

export interface IApplicantReport extends TApplicantReport {}

const ApplicantReport = Model(
  (model: TApplicantReport): IApplicantReport => {
    const _applicantReport: TApplicantReport = Object.assign({}, model);

    return {
      get applicantId() {
        return _applicantReport.applicantId;
      },

      get partyId() {
        return _applicantReport.partyId;
      },

      get firstName() {
        return _applicantReport.firstName;
      },

      get lastName() {
        return _applicantReport.lastName;
      },

      get fatherName() {
        return _applicantReport.fatherName;
      },

      get motherSurname() {
        return _applicantReport.motherSurname;
      }
    };
  }
);

export default ApplicantReport;
